<div class="db-my-sites">
  <div class="db-my-sites__add-website" *ngIf="website?.isNetwork && website.domain_hash">
    <div class="db-my-sites-search-wrap">
      <ds-search-input [formControl]="searchTerm" [placeholder]="'text_searchEllipsis' | dbText" [hasSearchIcon]="true"></ds-search-input>
    </div>
    <a class="ds-btn-blue" (click)="addWebsiteDialog()"><span>{{'text_sideBarAddWebsite' | dbText}}</span></a>
  </div>

  <div class="db-my-sites_empty-search" [ngClass]="{'db-search': (websites$ | async) && (websites$ | async).length && filteredWebsites && !filteredWebsites.length}">
    <db-empty-search [hideImage]="true" *ngIf="(websites$ | async) && (websites$ | async).length && filteredWebsites && !filteredWebsites.length"></db-empty-search>
  </div>

  <div *ngIf="filteredWebsites" class="db-my-sites__websites">
    <ng-container *ngFor="let website of filteredWebsites; trackBy: websiteTrackBy; let i=index;">
      <db-website-item-list-view [subscriptionId]="userSubscription?.subscriptionId" [website]="website"
                                 [isRootSubSite]="i === 0">
      </db-website-item-list-view>
    </ng-container>
  </div>
</div>

